module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "modalTitle": 'Add Custom Slot'
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('FormulateForm', {
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, [_c('FormulateInput', {
    attrs: {
      "type": "checkbox",
      "name": "is_available",
      "label": "Available"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date_input"
  }, [_c('FormulateInput', {
    attrs: {
      "type": "date",
      "name": "start_date",
      "label": "Start Date",
      "validation": "required",
      "validation-messages": {
        required: 'Start Date is required'
      }
    },
    on: {
      "validation": _vm.checkValidation
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "time",
      "name": "start_time",
      "label": "Start Time"
    },
    on: {
      "validation": _vm.checkValidation
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "date",
      "name": "end_date",
      "label": "End Date",
      "validation": "required|afterStart",
      "validation-rules": {
        afterStart: _vm.afterStart
      },
      "validation-messages": {
        required: 'End Date is required',
        afterStart: 'End Date must be after Start Date'
      }
    },
    on: {
      "validation": _vm.checkValidation
    }
  }), _vm._v(" "), _c('FormulateInput', {
    attrs: {
      "type": "time",
      "name": "end_time",
      "label": "End Time"
    },
    on: {
      "validation": _vm.checkValidation
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f51fcd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AgentScheduleCustomSlotModal.vue
// module id = 622
// module chunks = 0